import { InlineText3, Tooltip } from '@cian/ui-kit';
import * as React from 'react';

import { TooltipContent } from '../TooltipContent';

import * as styles from './index.css';
import { ICoworkingProfitBannerViewProps } from './types';

export const CoworkingProfitBannerView = React.forwardRef<HTMLButtonElement, ICoworkingProfitBannerViewProps>(
  (props, ref) => {
    const { onClose, onOpen, open } = props;

    return (
      <article className={styles['container']}>
        <Tooltip
          onOpen={onOpen}
          onClose={onClose}
          open={open}
          placement="bottom"
          theme="white"
          title={<TooltipContent />}
        >
          <button ref={ref} className={styles['button']}>
            <InlineText3 color="white_100">Почему это выгодно?</InlineText3>
          </button>
        </Tooltip>
      </article>
    );
  },
);

CoworkingProfitBannerView.displayName = 'CoworkingProfitBannerView';
